import React from 'react';
import { CLOSE_ICON } from '@marvelapp/theme';
import Icon from './Icon';
import Button from './Button';
export default function SearchCloseButton({ onClick, onMouseDown }) {
    return (React.createElement(Button, { bg: "transparent", "data-testid": "search-close-button", height: 24, marginTop: -12, onClick: onClick, onMouseDown: onMouseDown, position: "absolute", px: 0, right: "6px", top: "50%", width: 24 },
        React.createElement(Icon, { "data-testid": "close-search-icon", paths: CLOSE_ICON })));
}
